export default {
  INIT: 'DELIVERY_ORDER/INIT',
  UPDATE_DATA: 'DELIVERY_ORDER/UPDATE_DATA',
  UPDATE_META: 'DELIVERY_ORDER/UPDATE_META',
}
